import OnProduct from './on_product.vue';

export default OnProduct;
